import React, { useEffect, useRef, useState } from "react";
import MobileHeader from "../../../layout/DriverLayout/Header";
import useVirtualViewport from "../../../../hooks/useVirtualViewport";
import { Box, Typography, useTheme } from "@mui/material";
import { useAppSelector } from "../../../../hooks/useRedux";
import BottomTabbar from "../../../layout/DriverLayout/BottomTabbar";
import InfoCircle from "../../../../media/images/icons/info-circle";
import { Link } from "react-router-dom";
import InfoBox from "./InfoBox";
import ContactInfoBox from "./ContactInfo";
import TicketsBox from "./TicketsBox";

export default function SuportPage() {
  const divRef = useRef<HTMLDivElement>(null);

  const { isOpenKeyboard } = useAppSelector((state) => state.setting);

  const [stepIndex, setStepIndex] = useState(4);

  const viewport = useVirtualViewport();
  const [hasScroll, setHasScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (divRef.current && divRef.current.scrollTop > 5) {
        // Do something when scrolled more than 20 pixels
        setHasScroll(true);
      } else {
        setHasScroll(false);
      }
    };

    if (divRef.current) {
      divRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      // Cleanup: remove the event listener when the component unmounts
      if (divRef.current) {
        divRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  return (
    <>
      <MobileHeader title={getHeaderTitle()} hasScroll={hasScroll} />
      <Box
        ref={divRef}
        sx={{
          flex: "1",
          overflowY: "auto",
          paddingX: "8px",
        }}
      >
        <InfoBox />
        <ContactInfoBox />
        <TicketsBox />
      </Box>

      {!isOpenKeyboard && <BottomTabbar />}
    </>
  );
}

function getHeaderTitle() {
  return (
    <Typography
      sx={{
        fontWeight: 600,
        color: "secondary.main",
        fontSize: 16,
      }}
    >
      پشتیبانی{" "}
    </Typography>
  );
}
